



































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action } from 'vuex-class'
import {Modal} from '@/components/common'
import {Room, InventoryItem} from '@/store/types'

@Component({
  components: {
    Modal,
  },
})

export default class InventoryAddMultipleItemsOverlay extends Vue {
  @Getter('activeItemTypeQuantity') public activeItemTypeQuantity!: number
  @Getter('activeItemType') public activeItemType!: any
  @Getter('activeRoom') public activeRoom!: Room
  @Getter('showInventoryAddMultipleItemsOverlay') public showInventoryAddMultipleItemsOverlay!: boolean
  @Mutation('setAddedItem') public setAddedItem!: any
  @Mutation('setInventoryNewItemOverlay') public setInventoryNewItemOverlay!: any
  @Mutation('setActiveItemType') public setActiveItemType!: any
  @Mutation('setInventoryAddMultipleItemsOverlay') public setInventoryAddMultipleItemsOverlay!: any
  @Mutation('resetActiveItem') public resetActiveItem!: any
  @Mutation('setActiveItemTypeQuantity') public setActiveItemTypeQuantity!: any
  @Mutation('resetActiveItemType') public resetActiveItemType!: any
  @Action('addRoomItem') public addRoomItem!: any
  @Action('openInventoryAddedItem') public openInventoryAddedItem!: any

  public item: any = {}
  public isCustomQuantity: boolean = false


  public get quantity() {
    return this.activeItemTypeQuantity
  }
  public set quantity(q) {
    this.setActiveItemTypeQuantity(q)
  }

  public closeCustomQuantity() {
      this.isCustomQuantity = false
  }

  public addNewItem() {
    const data: any = {
      inventory_id: this.item.id,
      lead_room_id: this.activeRoom.id,
      quantity: this.quantity,
    }

    this.addRoomItem(data).then((res: InventoryItem) => {
      this.setActiveItemTypeQuantity(1)
      this.resetActiveItemType()
    })
    this.openInventoryAddedItem()
    this.setAddedItem(this.item)
    this.closeModal()
  }

  public showSingleItem() {
    this.setInventoryNewItemOverlay(true)
    this.setActiveItemTypeQuantity(this.quantity)
    this.setInventoryAddMultipleItemsOverlay(false)
  }

  public closeModal() {
    this.setActiveItemTypeQuantity(1)
    this.resetActiveItemType()
    this.setInventoryAddMultipleItemsOverlay(false)
  }

  public decreaseQuantity() {
    if (this.quantity > 1) {
      this.quantity--
    }
  }

  public increaseQuantity() {
    this.quantity++
  }

  public mounted() {
    this.item = Object.assign({}, this.activeItemType)
  }
}
